import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const affiliateSelector = createFeatureSelector<IState>('affiliate');
export const getAffiliatesSelector = createSelector(affiliateSelector, (state: IState | any) => state);
export const getAffiliateSelector = createSelector(affiliateSelector, (state: IState) => state.selectedItem);
